export const CONCLUDED_AUDIT_STATUSES = ['completed', 'validated', 'ready', 'approved'] as const;

export function isConcludedAuditStatus(status?: string | null) {
  return CONCLUDED_AUDIT_STATUSES.includes((status || '') as (typeof CONCLUDED_AUDIT_STATUSES)[number]);
}

